import { IPageParams } from '@/types/service';
import { get, post, put, remove } from '@/utils/request';
import { PayType } from '@/types/payment';
import type { OrderPaymentParams, PaymentInfo, PaymentResult, PaymentRequestContext, PaymentTransactionParams } from '@/types/payment';

/**
 * @description 获取套餐
 */
export const getPayPlanPage = async ({ current, pageSize }: IPageParams) => {
  return await get(`/api/payPlan/page`, {
    params: {
      current,
      pageSize,
    },
  });
};

export const createPlan = async (data: any) => {
  return await post(`/api/payPlan/create`, { data });
};

export const editPayPlan = async (data: any) => {
  return await put(`/api/payPlan/updateById`, { data });
};

export const removePayPlan = async (id: number | string) => {
  return await remove(`/api/payPlan/${id}`);
};

export const getPayPlanList = async () => {
  return await get(`/api/payPlan/list`, {});
};

/**
 * @description 获取支付信息
 */
export const getPayInfo = async (params: OrderPaymentParams, context?: PaymentRequestContext) => {
  return await get<PaymentResult<PaymentInfo>>(`/api/v1/pay/payInfo`, {
    ...context,
    params: {
      ...params,
    },
  });
};

/**
 * @description 传递支付信息
 */
export const postPayInfo = async (data: PaymentTransactionParams, context?: PaymentRequestContext) => {
  return await post<PaymentResult>(`/api/v1/pay/payTransaction`, { ...context, data });
};

/**
 * @description 信用卡支付
 */
export const postCard = async (data: OrderPaymentParams, context?: PaymentRequestContext) => {
  return await post<PaymentResult<string>>(`/api/v1/pay/card`, { ...context, data });
};

/**
 * @description 支付宝支付
 */
export const postAlipay = async (data: OrderPaymentParams, context?: PaymentRequestContext) => {
  return await post<PaymentResult<string>>(`/api/v1/pay/alipay`, { ...context, data });
};

/**
 * @description 支付宝支付
 */
export const postBlockchain = async (data: OrderPaymentParams, context?: PaymentRequestContext) => {
  return await post<PaymentResult<string>>(`/api/v1/pay/blockchain`, { ...context, data });
};

export const requestOrderPayment = (params: OrderPaymentParams, context?: PaymentRequestContext): Promise<PaymentResult<PaymentInfo | string>> => {
  switch (params.addressType) {
    case PayType.Alipay: return postAlipay(params, context);
    case PayType.Card: return postCard(params, context);
    case PayType.Blockchain: return postBlockchain(params, context);
    default: return getPayInfo(params, context);
  }
};

/**
 * @description 套餐余额购买
 */
// export const balancePurchasePlan = async (params: {
//   planId: number;
//   totalPrice: number;
//   isPlanStep: boolean;
//   number: number;
// }) => {
//   return await get(
//     `/api/purchase/plan/${params?.planId}?isBalancePurchase=true&totalPrice=${params.totalPrice}&isPlanStep=${params?.isPlanStep}&number=${params?.number}`,
//   );
// };

/**
 * @description 支付类型
 */
export const payTypeUse = async () => {
  return await get(`/api/v1/pay/payTypeUse`);
};

/**
 * @description 算钱
 */
export const calculatePackagePrice = async (params: any) => {
  return await get(`/api/planStep/calculatePackagePrice`, {
    params: {
      ...params,
    },
  });
};
